import { render, staticRenderFns } from "./corseManageModule.vue?vue&type=template&id=f94cda96&scoped=true"
import script from "./corseManageModule.vue?vue&type=script&lang=js"
export * from "./corseManageModule.vue?vue&type=script&lang=js"
import style0 from "./corseManageModule.vue?vue&type=style&index=0&id=f94cda96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94cda96",
  null
  
)

export default component.exports